import React from "react";
import "./flexStyles.scss";

const FlexRow = React.forwardRef(({
  justifyContent = "center",
  alignItems = "center",
  flexWrap = "wrap",
  width = "100%",
  gap = "1rem",
  className = '',
  onClick = null,
  styles,
  id,
  children,
  ...rest
}, ref) => {
  return (
    <div
      id={id}
      ref={ref}
      className={`flex-box-flex-row ${className}`}
      style={{
        justifyContent,
        alignItems,
        flexWrap,
        gap,
        width,
        ...styles
      }}
      onClick={() => {
        if (onClick) onClick();
      }}
      {...rest}
    >
      {children}
    </div>
  );
})

export default FlexRow;
